import React from 'react'
import useSmartviewMounter from '../hooks/use-smartview-mounter'

function MountSmartviewOnClick (props) {
  const mount = useSmartviewMounter(props.smartview, props.replace, props.keepTreeOnPush)

  const handleClick = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    mount()
  }

  return (
    <>
      {React.Children.map(props.children, child => (
        React.cloneElement(child, { onClick: handleClick })
      ))}
    </>
  )
}

MountSmartviewOnClick.defaultProps = {
  smartview: null,
  replace: true,
  keepTreeOnPush: false
}

export default MountSmartviewOnClick
